import { poUploadJobIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const uploadPurchaseOrders = {
  name: "uploadPurchaseOrders" as const,
  input: z.object({}),
  output: z.object({ jobId: poUploadJobIdFormat.schema }),
};
